<template>
  <v-dialog v-model="dialog" persistent max-width="720px">
    <v-card grid-list-md>
      <v-toolbar dense class="mb-3" flat color="grey lighten-3">
        <v-toolbar-title class="subtitle-1">Edit Delivery</v-toolbar-title>
        <v-spacer> </v-spacer>

        <v-btn small icon @click.stop.prevent="close()">
          <v-icon small>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-container>
        <v-row>
          <v-col cols="12" sm="12">
            <v-card :color="$style.purchase.titlebar" outlined>
              <v-card-title class="text-h6">
                <v-icon left>mdi-calendar-clock</v-icon>
                Select Delivery Date & Time
              </v-card-title>
              <v-card-text>
                <DateTimeSelector
                  v-model="deliveryDate"
                  label="Delivery Date"
                  :initValue="deliveryDate"
                  :resetKey="dateTimeResetKey"
                ></DateTimeSelector>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="8">
            <v-col cols="12" sm="12">
              <v-row>
                <v-col cols="12" sm="12">
                  <CustomerAutoComplete
                    v-model="selectedCustomer"
                    @reset="$emit('reset')"
                  ></CustomerAutoComplete>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-select
                    :items="Invoices"
                    outlined
                    rounded
                    hide-details
                    prepend-inner-icon="search"
                    dense
                    :loading="loading"
                    auto-select-first
                    label="Select Invoice"
                    single-line
                    clearable
                    item-text="localId"
                    return-object
                    v-model="selectedInvoice"
                  >
                    <template slot="item" slot-scope="{ item }">
                      <div>
                        <div class="font-weight-bold">{{ item.localId }}</div>
                        <small>{{ item.date | moment("L LT") }}</small>
                      </div>
                      <v-spacer></v-spacer>
                      <span class="font-weight-bold">{{
                        item.total | currency
                      }}</span>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model.trim="Delivery.name"
                    :error-messages="nameErrors"
                    :hide-details="nameErrors.length === 0"
                    outlined
                    @focus="$event.target.select()"
                    dense
                    label="Name"
                    ref="deliveryName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="Delivery.deliveryType"
                    :items="deliveryTypes"
                    label="Delivery Type"
                    outlined
                    dense
                    hide-details
                    clearable
                  ></v-select>
                </v-col>

                <v-col
                  cols="12"
                  sm="12"
                  v-if="Delivery.deliveryType === 'Shipping'"
                >
                  <v-text-field
                    v-model="Delivery.trackingNumber"
                    label="Tracking Number"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-textarea
                    counter="counter"
                    hide-details
                    outlined
                    dense
                    auto-grow
                    v-model="Delivery.note"
                    label="Description"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-card dark>
              <div v-if="deliveryInfo && deliveryInfo.length">
                <v-subheader class="pt-2 pb-1"
                  >Delivery on this day</v-subheader
                >
                <v-list dense>
                  <v-list-item
                    v-for="(delivery, index) in deliveryInfo"
                    :key="index"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        {{ delivery.name || "Unnamed Delivery" }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ delivery.deliveryDate | moment("MM/DD") }} |
                        {{ formatTime(delivery.startTime) }} -
                        {{ formatTime(delivery.endTime) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>
      <v-card-actions>
        <!-- <MoreImage :imageResult="imageResult" @submit="imageChange" /> -->

        <v-spacer></v-spacer>
        <v-btn color="primary" text="text" @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import GlobalFunction from "@/mixins/GlobalFunction";
import { mapGetters } from "vuex";
import CustomerAutoComplete from "@/modules/Customer/components/AutoComplete";
const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");
import InvoiceService from "@/modules/Invoice/service.js";
import deliveryService from "@/modules/Delivery/service.js";
import DateTimeSelector from "@/components/DateTimeSelector";

export default {
  props: {
    editDialog: {
      default: false,
    },
    id: {
      default: 0,
    },
  },
  name: "edit-delivery",
  data() {
    return {
      deliveryTypes: ["Shipping", "Pickup", "Delivery", "Pickup from Shop"],
      dateTimeResetKey: 0,
      deliveryDate: {},
      Delivery: {
        name: null,
        deliveryDate: null,
        startTime: null,
        endTime: null,
        note: null,
        InvoiceId: null,
        deliveryOrder: null,
        deliveryType: null,
        trackingNumber: null,
      },
      dialog: false,
      loading: false,
      deliveryInfo: null,
      Invoices: [],
      selectedInvoice: null,
      selectedCustomer: null,
    };
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    Delivery: {
      name: {
        required,
        minLength: minLength(4),
      },
      // CategoryId: {
      //   required,
      //   minValue: minValue(1),
      // },
    },
  },
  components: {
    CustomerAutoComplete,
    DateTimeSelector,
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Delivery.name.$dirty) return errors;
      if (!this.$v.Delivery.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Delivery.name.minLength)
        errors.push("Field must be at least 4 characters long");
      return errors;
    },
  },
  watch: {
    deliveryDate(val) {
      if (val && val.date) {
        this.Delivery.deliveryDate = val.date;
        this.getDeliveryByDate(val.date); // fetch data when date is selected
      }
      if (val && val.startTime) {
        this.Delivery.startTime = val.startTime;
      }
      if (val && val.endTime) {
        this.Delivery.endTime = val.endTime;
      }
    },
    selectedInvoice(val) {
      if (val) {
        this.Delivery.name = `${this.selectedCustomer.name} | Inv#${val.localId}`;
        this.Delivery.InvoiceId = val.id;
      }
    },
    selectedCustomer(val) {
      if (val) {
        this.getInvoiceList();
        this.Delivery.name = `${this.selectedCustomer.name} `;
      }
    },
    editDialog(val) {
      this.dialog = val;
      this.getDelivery();
    },
  },
  methods: {
    getDelivery() {
      if (this.id) {
        this.loading = true;
        return deliveryService.getById(this.id).then((response) => {
          console.log("response", response);
          this.loading = false;
          this.Delivery = response.data;
          if (this.Delivery.deliveryDate) {
            this.Delivery.deliveryDate = this.$moment(
              this.Delivery.deliveryDate
            ).toISOString();
          }
          if (this.Delivery.startTime) {
            this.Delivery.startTime = this.$moment(
              this.Delivery.startTime,
              "HH:mm"
            ).toISOString();
          }
          if (this.Delivery.endTime) {
            this.Delivery.endTime = this.$moment(
              this.Delivery.endTime,
              "HH:mm"
            ).toISOString();
          }
          // this.deliveryDate = {
          //   date: this.$moment(this.Delivery.deliveryDate).toDate(),
          //   startTime: this.$moment(this.Delivery.startTime, "HH:mm").toDate(),
          //   endTime: this.$moment(this.Delivery.endTime, "HH:mm").toDate(),
          // };
          this.deliveryDate = {
            date: this.$moment(this.Delivery.deliveryDate).toDate(),
            startTime: this.$moment(this.Delivery.startTime, "HH:mm").toDate(),
            endTime: this.$moment(this.Delivery.endTime, "HH:mm").toDate(),
          };

          if (this.Delivery.Invoice) {
            this.selectedInvoice = {
              id: this.Delivery.InvoiceId,
              localId: this.Delivery.Invoice.localId,
            };
          }
          if (this.Delivery.Customer) {
            this.selectedCustomer = {
              id: this.Delivery.CustomerId,
              name: this.Delivery.Customer.name,
            };
          }
        });
      }
    },
    formatTime(time) {
      if (!time) return "Not Set";
      return this.$moment(time, "HH:mm").format("hh:mm A");
    },
    getInvoiceList() {
      let where = {
        CustomerId: this.selectedCustomer.id,
        start: this.$moment()
          .startOf("days")
          .subtract(90, "days")
          .toISOString(),
      };

      this.loading = true;
      return InvoiceService.getAll(where).then((response) => {
        console.log("response", response);
        this.loading = false;
        this.Invoices = response.data;
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Delivery = {
        name: null,
        note: null,
        deliveryDate: null,
        startTime: null,
        endTime: null,
        InvoiceId: null,
        deliveryOrder: null,
        deliveryType: null,
        trackingNumber: null,
      };
      this.dateTimeResetKey = Date.now();
      this.deliveryInfo = null;
      this.Invoices = [];
      this.selectedInvoice = null;
      this.selectedCustomer = null;
      this.deliveryDate = {};
      this.$v.$reset();
    },
    getDeliveryByDate(date) {
      if (!date) return;

      // const startOfDay = this.$moment.utc(date).startOf("day").toISOString();
      // const endOfDay = this.$moment.utc(date).endOf("day").toISOString();

      const startOfDay = this.$moment
        .utc(date)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss"); // '2025-05-30 00:00:00'
      const endOfDay = this.$moment
        .utc(date)
        .endOf("day")
        .format("YYYY-MM-DD 00:00:00"); // '2025-05-30 23:59:59'

      // console.log("startOfDay", startOfDay);
      // console.log("endOfDay", endOfDay);
      this.loading = true;
      deliveryService
        .getAll({ start: startOfDay, end: endOfDay })
        .then((response) => {
          this.deliveryInfo = response.data;

          // Set deliveryOrder based on how many Delivery exist already
          this.Delivery.deliveryOrder = (response.data.length || 0) + 1;

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.error("Error fetching Delivery:", err);
        });
    },
    submit() {
      this.$v.$touch();
      // Check if delivery date is missing
      if (!this.Delivery.deliveryDate) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Delivery date must be selected before saving.",
          });
        return;
      }
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        // this.Delivery.deliveryDate =
        console.log("this.Delivery", this.Delivery);
        // return false;
        return deliveryService
          .update(this.id, this.Delivery)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Product is created",
                });
              this.empty();
              this.loading = false;
              this.$emit("submit");
            }
          })
          .catch((err) => {
            // console.log("error", err);
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
